<template>
  <el-button
    type="primary"
    :disabled="!!$attrs.disabled"
    @click="FBADownExcl"
    style="margin-bottom: 10px"
    >下载EXCEL</el-button
  >
</template>

<script>
import axios from "axios";
import { downloadcarton } from "@/apis/outStock";
import { baseURL } from "@/const/env";
export default {
  name: "FBAExclDown",
  props: {
    //
    record: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      domain: {
        development: "", // 开发
        production: "", // 生产
        test: "", // 测试
      },
    };
  },
  methods: {
    FBADownExcl: function () {
      if (!this.record) {
        this.$message.error("出库单错误！");
        return;
      }
      let params = {
        deliveryTaskCode: this.record.deliveryTaskCode,
      };
      downloadcarton(params).then((res) => {
        console.log(res)
        let blobObj = new Blob([res.data]);
        let blobUrl = window.URL.createObjectURL(blobObj);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "装箱清单.xlsx";
        link.click();
        window.URL.revokeObjectURL(link.href);
      });
    },
    // 释放流文件
    blobFreed: function (params, deliveryCode) {
      if (!this.record) {
        this.$message.error("出库单错误！");
        return;
      }
      const that = this;
      const service = axios.create({
        // baseURL: that.domain[baseUrl], // auto
        baseURL: baseURL(), // test
        timeout: 9000, // 请求超时时间
      });
      service
        .post("/amazonApi/inbound/download/carton/info/excel", params, {
          // headers: {
          //   'Content-Type':'application/json',
          // },
          responseType: "blob", // 表明返回服务器返回的数据类型
        })
        .then((res) => {
          console.log("res", res);
          const content = res.data;
          const blob = new Blob([content]);
          const fileName = !!deliveryCode ? `${deliveryCode}.xls` : "FBA.xls";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
</style>